// Helper to safely call gtag from anywhere
export function gtagEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

// Retry-version for critical events (conversions) — waits for gtag.js to load
export function gtagEventReliable(eventName: string, params?: Record<string, unknown>): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') { resolve(); return; }

    let attempts = 0;
    const maxAttempts = 50; // 50 x 200ms = 10 seconds max wait

    const tryFire = () => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
        resolve();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryFire, 200);
      } else {
        // Fallback: push to dataLayer directly so it's processed when gtag loads
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...params });
        resolve();
      }
    };
    tryFire();
  });
}

// Enhanced Conversions — set user data for better conversion matching
export function gtagSetUserData(data: {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  street?: string;
  city?: string;
  postalCode?: string;
  country?: string;
}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const userData: Record<string, unknown> = {};
  if (data.email) userData.email = data.email.trim().toLowerCase();
  if (data.phone) {
    // Normalize to E.164 (Swedish numbers)
    let phone = data.phone.replace(/[\s\-()]/g, '');
    if (phone.startsWith('0')) phone = '+46' + phone.slice(1);
    if (!phone.startsWith('+')) phone = '+46' + phone;
    userData.phone_number = phone;
  }
  if (data.firstName || data.lastName || data.street || data.city || data.postalCode) {
    userData.address = {
      ...(data.firstName && { first_name: data.firstName }),
      ...(data.lastName && { last_name: data.lastName }),
      ...(data.street && { street: data.street }),
      ...(data.city && { city: data.city }),
      ...(data.postalCode && { postal_code: data.postalCode }),
      country: data.country || 'SE',
    };
  }
  window.gtag('set', 'user_data', userData);
}
